import { Controller } from "@hotwired/stimulus"

// Cosmetic-only live preview for the cover photo file input — all the real
// validation (size/type/magic-bytes) happens server-side once the form is
// submitted (see app/models/concerns/image_attachment_validatable.rb).
export default class extends Controller {
  static targets = ["image"]

  change(event) {
    const file = event.target.files[0]
    if (!file || !this.hasImageTarget) return

    this.imageTarget.src = URL.createObjectURL(file)
    this.imageTarget.closest(".photo-preview")?.classList.remove("u-hidden")
  }
}
